// Format number with commas
const formatNumber = (number) => {
  if (!number) return '';
  const parts = number.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};

// Handle number input for price (allows decimals)
export const handlePriceInput = (value) => {
  // Remove any existing commas
  const rawValue = value.replace(/,/g, '');
  // Only allow numbers and decimal point
  if (/^\d*\.?\d*$/.test(rawValue)) {
    return rawValue;
  }
  return value;
};

// Handle number input for stock/amount (whole numbers only)
export const handleWholeNumberInput = (value) => {
  // Remove any existing commas
  const rawValue = value.replace(/,/g, '');
  // Only allow whole numbers
  if (/^\d*$/.test(rawValue)) {
    return rawValue;
  }
  return value;
};

export default formatNumber;